export const CryptoToken = {
    token: "THAWANI_895678CFA_TWA_OMN_$_%"
}